import { IRoomType } from "@/models/room/RoomType";
import axios from "axios";

export default class RoomTypeService {
  static async getBorrowingRoomType(
    roomLocationId: string
  ): Promise<IRoomType[]> {
    try {
      const res = await axios.get(
        import.meta.env.VITE_API_URL + "room-type/borrowing",
        {
          params: {
            room_location_id: roomLocationId,
          },
          withCredentials: true,
        }
      );

      return res.data.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  }
}
